// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const _ = require('lodash');

const deps = [];

const lodashFiltersModule = angular.module('bench.data.service.lodashFilters', deps);

const stringMethods = [
  'camelCase',
  'capitalize',
  'deburr',
  'escape',
  'escapeRegExp',
  'kebabCase',
  'pad',
  'padStart',
  'padEnd',
  'snakeCase',
  'startCase',
  'trim',
  'trimStart',
  'trimEnd',
  'truncate',
  'unescape',
  'words',
];

_.each(stringMethods, methodName => {
  const filterFactory = () => _.bind(_[methodName], _);

  return lodashFiltersModule.filter(`_${methodName}`, filterFactory);
});

module.exports = lodashFiltersModule;
